import React from 'react';
import PropTypes from 'prop-types';
import renderIf from 'render-if';
import cn from 'classnames';
import PostingTile from 'components/PostingTile';
import ListView from 'components/ListView';

import styles from '../DashboardView.scss';
import Nocontentfound from '../Tutorial/Nocontentfound';

const PostingView = (props) => {
  // let countForSchool = 0;
  const { contactedList, ignoreList, postings, addToList,
           profileId, addToRequest, gridView, showSnackBar } = props;
  const renderNoContentFound = renderIf(postings.size === 0);
  return (
    <div className={cn('col s12', styles.alignCenter)}>
      {renderNoContentFound(<Nocontentfound text="" />)}
      {postings.map((item) => {
        const interested = contactedList.indexOf(item.get('college_id')) > -1;
        const ignoreListId = ignoreList.indexOf(item.get('college_id')) > -1 || interested;
        if (ignoreListId) {
          return null;
        }
        // countForSchool++; //eslint-disable-line
        // if (countForSchool > 25) {
        //   return null;
        // }
        return (
          <span>
            {gridView ?
              <PostingTile
                posting={item}
                addToList={addToList}
                profileId={profileId}
                addToRequest={addToRequest}
                interested={interested}
                {...props}
                showCounterScreen={props.showCounterpopUp}
                showSnackBar={showSnackBar}
              />
              :
              <ListView
                posting={item}
                addToList={addToList}
                profileId={profileId}
                addToRequest={addToRequest}
                interested={interested}
                showCounterScreen={props.showCounterpopUp}
                {...props}
                showSnackBar={showSnackBar}
              />
            }
          </span>
        );
      })}
    </div>
  );
};

PostingView.propTypes = {
  addToList: PropTypes.func.isRequired,
  addToRequest: PropTypes.func.isRequired,
  contactedList: PropTypes.shape.isRequired,
  ignoreList: PropTypes.shape.isRequired,
  profileId: PropTypes.string.isRequired,
  gridView: PropTypes.bool.isRequired,
  postings: PropTypes.shape.isRequired,
  showSnackBar: PropTypes.func.isRequired,
  showCounterpopUp: PropTypes.func.isRequired,
};

export default PostingView;




// WEBPACK FOOTER //
// ./src/components/DashboardView/Default/postingview.js